export default __webpack_public_path__ + "assets/images/e89e817e9892fa68a1cb377927e1c2c8.png";